import { Component } from '@angular/core';

@Component({
  selector: 'sana-tp-not-found-page',
  imports: [],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.scss'
})
export class NotFoundPageComponent {

}
